export default __webpack_public_path__ + "static/tv-show-9-704d1c09854196465edd350a313bd356.jpg";